import MindwellSigStamp from '../../assets/images/mindwell_sig.png';

function Stamp(props) {

    return (<img id="stamp" src={MindwellSigStamp} />)
}


export default Stamp;
